<template>
  <span class="skeleton-box page__slide"></span>
</template>

<script>
export default {}
</script>

<style scoped>
.skeleton-box {
  display: block;
  width: 100%;
  height: 99vh;
  background: linear-gradient(90deg, #ddd 0, #e8e8e8 6rem, #ddd 12rem);
  animation: shine 5s infinite linear;
}
@keyframes shine {
  0% {
    background-position: -100vw;
  }
  100% {
    background-position: 100vw;
  }
}
</style>
